import {
  GatsbyImage,
  GatsbyImageProps,
  withArtDirection,
} from "gatsby-plugin-image";
import {
  cleanApiPath,
  getImageFromGatsby,
} from "../../../utils/getImageFromGatsby";
import { useCmsImages } from "../../../utils/useCmsImages";
import { graph } from "./styles.css";
import classNames from "classnames";
import { LAPTOP_SCREEN_MQ } from "../../../../shared/constants/breakpoints";

type Props = {
  image: string;
  laptopSizeImage?: string;
  alt: string;
  className?: string;
} & Omit<GatsbyImageProps, "image" | "alt" | "className">;

const isSvg = (src: string) => src.trim().toLowerCase().endsWith(".svg");

export const CmsImage = ({
  image,
  laptopSizeImage,
  alt,
  className,
  ...rest
}: Props) => {
  const files = useCmsImages();
  const baseImage = getImageFromGatsby(image, files);

  if (isSvg(image) || !baseImage) {
    const cleanedImage = cleanApiPath(image);
    const cleanedLaptopImage = laptopSizeImage && cleanApiPath(laptopSizeImage);
    return (
      <picture>
        {cleanedLaptopImage && (
          <source
            key={cleanedLaptopImage}
            media={LAPTOP_SCREEN_MQ}
            srcSet={`/${cleanedLaptopImage}`}
          />
        )}
        <img
          className={classNames(isSvg(image) ? graph : image, className)}
          src={`/${cleanedImage}`}
          alt={alt}
        />
      </picture>
    );
  }

  const laptopImage = laptopSizeImage
    ? getImageFromGatsby(laptopSizeImage, files)
    : undefined;

  if (!baseImage) return null;

  const artDirectedImage = laptopImage
    ? withArtDirection(baseImage, [
        { media: LAPTOP_SCREEN_MQ, image: laptopImage },
      ])
    : baseImage;

  return (
    <GatsbyImage
      image={artDirectedImage}
      alt={alt}
      className={classNames(image, className)}
      {...rest}
    />
  );
};
